function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M22 17v3a3 3 0 0 1-3 3h-2a3 3 0 0 1-3-3v-3h-3v2H9v-2H7a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h2v-9h2v9h14v-9h2v9h2a1 1 0 0 0 1-1V18a1 1 0 0 0-1-1h-2v2h-2v-2h-3zM2.442 14C.81 14-.163 13.536.015 12.228c.05-.357.19-.676.459-1.153.017-.03.489-.836.631-1.099C1.676 8.924 1.97 8.01 1.97 7s-.293-1.924-.864-2.976c-.142-.263-.614-1.07-.631-1.1-.27-.476-.41-.795-.459-1.152C-.163.464.81 0 2.442 0c4.011 0 7 3.064 7 7s-2.989 7-7 7zm0-2c2.895 0 5-2.157 5-5s-2.105-5-5-5c-.068 0-.132 0-.19.002.115.198.477.82.612 1.069C3.579 4.39 3.969 5.606 3.969 7c0 1.394-.39 2.61-1.105 3.93-.135.249-.498.87-.613 1.068l.19.002zM7 15h22a3 3 0 0 1 3 3v11a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3V18a3 3 0 0 1 3-3zm7-2h-2v-2a3 3 0 0 1 3-3h6a3 3 0 0 1 3 3v2h-2v-2a1 1 0 0 0-1-1h-6a1 1 0 0 0-1 1v2zm2 4v3a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-3h-4z"
});

var SvgBoarding = function SvgBoarding(props) {
  return React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "#1B1F23",
    viewBox: "0 0 32 32"
  }, props), _ref);
};

export default __webpack_public_path__ + "93a81f7b00e4f73c1414d3ed6c555dda.svg";
export { SvgBoarding as ReactComponent };


//////////////////
// WEBPACK FOOTER
// ../icons/svg/boarding.svg
// module id = null
// module chunks = 